export var SIDEBAR_WIDTH = 333;